export const normalizeThemeOnBoot = (storage = window?.localStorage) => {
  if (!storage) return false;

  const storedTheme = storage.getItem("theme");
  if (storedTheme !== "light" && storedTheme !== "dark") {
    storage.setItem("theme", "dark");
  }

  return false;
};

